document.addEventListener('DOMContentLoaded', function () {
  const buyBar = document.querySelector('.buy-bar');

  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

    if (scrollTop < 720) {
      buyBar.classList.remove('is-visible');
    } else {
      buyBar.classList.add('is-visible');
    }
  }
});
